// Don't transform it to a hook
const getUserInfo = (): {
    sNombre: string
    bAdmin?: boolean
    cLocal: {
        sLocal: string
        sNombreLocal: string
        sDireccion: string
    }[]
} => {
    const currentUser = localStorage.getItem('currentUser')
    return JSON.parse(currentUser || '')
}
const getLocalName = (): string => {
    let selectedLocal = localStorage.getItem('selectedLocal')
    const info = getUserInfo()
    if (!info.bAdmin) {
        selectedLocal = info.cLocal[0].sLocal
    }
    let name = info?.sNombre || ''
    if (selectedLocal) {
        name =
            info.cLocal.find((local) => local.sLocal === selectedLocal)
                ?.sNombreLocal || name
    }
    return name
}
const getLocalAddress = (): string => {
    let selectedLocal = localStorage.getItem('selectedLocal')
    const info = getUserInfo()
    if (!info.bAdmin) {
        selectedLocal = info.cLocal[0].sLocal
    }
    let addressLocal = info?.sNombre || ''
    if (selectedLocal) {
        addressLocal =
            info.cLocal.find((local) => local.sLocal === selectedLocal)
                ?.sDireccion || addressLocal
    }
    return addressLocal
}
const getLocal = () => {
    const selectedLocal = localStorage.getItem('selectedLocal')
    if (isAdmin() && selectedLocal) {
        return selectedLocal
    }
    const currentUser = localStorage.getItem('currentUser')

    const user = currentUser && JSON.parse(currentUser)

    if (Array.isArray(user.cLocal) && user.cLocal.length > 0) {
        return user.cLocal[0]?.sLocal
    }

    return null
}
const getLocalId = () => {
    const selectedLocal = localStorage.getItem('selectedLocalId')
    if (isAdmin() && selectedLocal) {
        return selectedLocal
    }
    const currentUser = localStorage.getItem('currentUser')

    const user = currentUser && JSON.parse(currentUser)

    if (Array.isArray(user.cLocal) && user.cLocal.length > 0) {
        return user.cLocal[0]?.idLocal
    }

    return null
}

const getJWT = () => {
    const currentUser = localStorage.getItem('currentUser')
    if (!currentUser) {
        return ''
    }
    const user = currentUser && JSON.parse(currentUser)

    return `Bearer ${user.token}`
}

const isAdmin = () => localStorage.getItem('isAdmin') == 'true'

const isLocalView = () => !isAdmin() || !!localStorage.getItem('selectedLocal')

const isLocalSelected = () => !!localStorage.getItem('selectedLocal')

export {
    isAdmin,
    isLocalView,
    getLocal,
    getJWT,
    getLocalId,
    getUserInfo,
    getLocalAddress,
    getLocalName,
    isLocalSelected,
}
